import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/instagram-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/instagram" });
	},
});
